import { isErrorStatus, isLoadingStatus, useResource } from 'json-api-hooks';
import React, { FC } from 'react';
import { useParams } from 'react-router';

import Collection from '../../../components/./Collection/Collection';
import ActionsBar from '../../../components/ActionsBar';
import CardContent from '../../../components/Card/CardContent';
import CardMain from '../../../components/Card/CardMain';
import CardMainHeader from '../../../components/Card/CardMainHeader';
import Container from '../../../components/Container';
import ErrorPage from '../../../components/Error/ErrorPage';
import { LoadingPage } from '../../../components/Loading';
import Markdown from '../../../components/Markdown';
import EventDropdownMenu from '../../../dropdownMenus/EventDropdownMenu';
import EventDetails from '../../../models/events/EventDetails';
import EventSignUpButton from '../../../models/events/EventSignUpButton';
import EventStreetTable from '../../../models/eventStreets/EventStreetTable';

const EventShow: FC = () => {
  const { id } = useParams();
  const [event, status] = useResource({ type: 'events', id });

  if (isLoadingStatus(status)) {
    return <LoadingPage />;
  }

  if (isErrorStatus(status) || !event) {
    return <ErrorPage />;
  }

  return (
    <Container>
      <CardMain>
        <CardContent>
          <CardMainHeader float={<EventDropdownMenu event={event} />} title={event.attributes.name} />
          <EventDetails event={event} />
          <Markdown text={event.attributes.description} />
        </CardContent>
        <ActionsBar>
          <EventSignUpButton event={event} />
        </ActionsBar>
      </CardMain>
      <Collection opts={{ filter: { eventId: [event.id] } }} resourceType="event_streets">
        <EventStreetTable eventId={event.id} />
      </Collection>
    </Container>
  );
};

export default EventShow;
